export const emptyStateProfile = (
  userData,
  followed,
  myProfile,
  type,
  data
) => {
  let title;
  let dis;
  let btn1;
  let btn2;
  if (!userData) {
    if (myProfile) {
      title = "You are not logged in";
      dis = "Tou should log into your account to view your profile.";
      btn1 = "table";
      btn2 = "login";
    } else {
      if (data) {
        if (type === 0) {
          title = "There is no opinion posted by this user";
          dis =
            "Log into your account, Then follow this user to inform about updates! Or find a new table.";
          btn1 = "table";
          btn2 = "login";
        }
        // if (type === 1) {
        //   title = "This user is not participated in any discussions";
        //   dis =
        //     "Log into your account, Then follow this user to inform about updates! Or find a new table.";
        //   btn1 = "table";
        //   btn2 = "login";
        // }
        if (type === 1) {
          title = "This user is not participated in any tables";
          dis =
            "Log into your account, Then follow this user to inform about updates! Or find a new table.";
          btn1 = "table";
          btn2 = "login";
        }
      }
    }
  } else {
    if (data) {
      if (myProfile) {
        if (type === 0) {
          title = "There is no opinion posted by you";
          dis = "You can add a new table and share your opinions.";
          btn1 = "table";
        }
        // if (type === 1) {
        //   title = "You do not participate in any discussions ";
        //   dis = "You can add a new table and discuss about your opinions.";
        //   btn1 = "table";
        // }
        if (type === 1) {
          title = "You do not participate in any tables";
          dis = "You can add a new table and share your thoughts.";
          btn1 = "table";
        }
      } else {
        if (followed) {
          if (type === 0) {
            title = "There is no opinion posted by this user";
            dis = "You can find a new table!";
            btn1 = "table";
          }
          // if (type === 1) {
          //   title = "This user does not participate in any discussions";
          //   dis = "You can find a new table!";
          //   btn1 = "table";
          // }
          if (type === 1) {
            title = "This user does not participate in any tables";
            dis = "You can find a new table!";
            btn1 = "table";
          }
        } else {
          if (type === 0) {
            title = "There is no opinion posted by this user";
            dis =
              "Follow this user to inform about updates! Or find a new table.";
            btn1 = "table";
            btn2 = "follow";
          }
          // if (type === 1) {
          //   title = "This user does not participate in any discussions";
          //   dis =
          //     "Follow this user to inform about updates! Or find a new table.";
          //   btn1 = "table";
          //   btn2 = "follow";
          // }
          if (type === 1) {
            title = "This user does not participate in any tables";
            dis =
              "Follow this user to inform about updates! Or find a new table.";
            btn1 = "table";
            btn2 = "follow";
          }
        }
      }
    }
  }

  return { title, dis, btn1, btn2 };
};
